const baseConfig = {
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};
const getConfig = (params) => {
  const config = {
    ...baseConfig,
  };
  if (params && params?.headers) {
    let headers = {
      ...baseConfig.headers,
      ...params.headers,
    };
    const customConfig = {
      headers: headers,
    };
    config.headers = customConfig.headers;
  }
  return config;
};

export const post = async (httpClient, endpoint, requestData) => {
  const config = getConfig();

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};

export const postFile = async (httpClient, endpoint, requestData) => {
  const config = getConfig({
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};

export const postWithCSVResponse = async (
  httpClient,
  endpoint,
  requestData
) => {
  const config = getConfig({
    headers: {
      "Content-Type": "application/xml",

      responseType: "blob",
    },
  });

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};
export const postWithImgResponse = async (
  httpClient,
  endpoint,
  requestData
) => {
  const config = {
    responseType: "arraybuffer",
  };

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};

export const postWithHeaders = async (httpClient, endpoint, requestData, headers) => {
  const config = getConfig({headers});
  // request data parsing logic can go here;

  const response = await httpClient.post(endpoint, requestData, config);

  if (response) {
    return response;
  }
  return;
};